"use strict";

/* todo: I want this to actually be an array of Function | string but that causes errors */
if (typeof exports !== "undefined") Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_StyleSheet", {
  value: require("prop-types").shape({
    create: require("prop-types").func.isRequired
  })
});

/* eslint-disable no-undef */


/*****************
 ** WEBPACK FOOTER
 ** ./~/styled-components/lib/types.js
 ** module id = 18
 ** module chunks = 0
 **/